/**
 * Pdf portal
 * Portal to generate PDF and handle authentication.
 *
 * OpenAPI spec version: 1.0.32
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { BantCalculatedResult } from './bantCalculatedResult';
import { CategoryGameResult } from './categoryGameResult';

/**
 * Base class serializer for all OpenAPI serializers.  It only implements create/update method without any logic to prevent \"abstract\" warning by pylint.
 */
export interface ScenarioCategoryResult { 
    childUuid: string;
    finishedAt: Date;
    scenarioUuid: string;
    uuid: string;
    categoryResults: Array<CategoryGameResult>;
    bantResultCalculated?: BantCalculatedResult;
    bantResultCalculatedZs?: BantCalculatedResult;
    solutionTime: number;
    administratedCount: number;
    itemsCount: number;
    institution?: string;
}